export default "__VITE_ASSET__D_ei4l5r__"